<div class="modal-content modal-confirm">
	<div class="modal-header modal-confirm__header">
		<button type="button" class="close" (click)="close()">&times;</button>
		<app-icon-warning class="modal-confirm__icon" iconCls="icon--danger"></app-icon-warning>
		<h4 class="modal-confirm__title">Facility missing invoicing group</h4>
	</div>
	<div class="modal-body modal-confirm__message">
		<ng-container *ngIf="hasFacilityErrors(); else fallbackMessage">
			<div class="modal__company" *ngFor="let company of facilityErrors">
				<h3 class="modal__company-title">Facility ID #{{ company.companyId }}</h3>
				<ul class="modal__facility-list">
					<li class="modal__facility" *ngFor="let facility of company.facilities">
						<h4>
							{{ getFacilityDisplayName(facility) }} –
							<a [href]="getFacilityContractLink(facility.facilityId)" target="_blank" rel="noopener">
								Open facility contract
							</a>
						</h4>
					</li>
				</ul>
			</div>
		</ng-container>

		<ng-template #fallbackMessage>
			<p class="modal__fallback">
				Please open the facility contract to assign an invoicing group, then try generating the invoice again.
			</p>
		</ng-template>
	</div>
	<div class="modal-footer modal-confirm__footer">
		<button type="button" class="btn btn--gray-1 m-r-10" (click)="onClose()">Close and reload page</button>
	</div>
</div>
